import { useEffect, useState } from "react";
import criteoSpotLightAdvert from "../api/criteoSpotLightApi";
import { useStockPrice } from "../context/stockPrice/StockPriceContext";
import { useRuntimeConstants } from "../context/runtimeConstants/RuntimeConstantsContext";
import isProduction from "../utils/isProduction";
import { logError, ERROR_TYPE } from "../utils/newRelicLogger";

const useCriteoSpotLight = () => {
  const [spotLightData, setSpotLightData] = useState(undefined);
  const { products } = useStockPrice();

  const { siteDomain } = useRuntimeConstants();
  const isProd = isProduction(siteDomain);

  useEffect(() => {
    const getSpotlightData = async () => {
      try {
        const spotLightResponse = await criteoSpotLightAdvert(products, isProd);

        if (spotLightResponse?.placements.length > 0) {
          const filteredResponse =
            spotLightResponse?.placements?.[0]?.[
              "viewItemApiDesktop-midBanner"
            ]?.[0];

          setSpotLightData(filteredResponse);
        }
      } catch (error) {
        logError(ERROR_TYPE.NonCriticalAppError, {
          message: error?.message ?? String(error),
          action: "CriteoSpotLightApi",
        });
        return undefined;
      }
    };

    const hasRequiredParams = Boolean(products?.id && products?.price);
    if (!spotLightData && hasRequiredParams) {
      getSpotlightData();
    }
  }, [spotLightData, products, isProd]);

  return spotLightData;
};

export default useCriteoSpotLight;
